import { ScreenDisplayType } from 'core/channelGroup/ChannelGroup';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';
import { CreativeListRecord } from 'core/creative/Creative';
import { useMemo } from 'react';
import { OutdoorCreativeDetail } from './OutdoorCreativeDetail';
import { MultiSplicedCreativeDetail } from './MultiSplicedCreativeDetail';

export const DynamicCreativeDetail: React.FC<{
  creative: Partial<CreativeListRecord>;
}> = ({ creative }) => {
  const screenDisplayType = useMemo(() => {
    if (!creative.creativeType) {
      return ScreenDisplayType.SINGLE;
    }
    const creativeTypeSetting = ChannelGroupSetting.creativeTypeSettings().get(
      creative.creativeType
    );
    if (!creativeTypeSetting) {
      return ScreenDisplayType.SINGLE;
    }
    const channelGroupTypeSetting = ChannelGroupSetting.fromId(
      creativeTypeSetting.channelGroupId
    );
    return channelGroupTypeSetting.getScreenDisplayTypeByCreativeType(
      creative.creativeType
    );
  }, [creative.creativeType]);

  return screenDisplayType === ScreenDisplayType.SINGLE ? (
    <OutdoorCreativeDetail creative={creative} />
  ) : (
    <MultiSplicedCreativeDetail creative={creative} />
  );
};
